import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { orgIdParam, productIdParam } from './builderHelper';

export const overviewResources = {
  getProductsList: createResourceBuilder(
    '/overview/org/:organization_id/list-products',
    EResourceMethod.Get,
    orgIdParam()
  ),
  listUserProducts: createResourceBuilder(
    '/overview/org/:organization_id/list-user-products',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getProductExamples: createResourceBuilder(
    '/overview/org/:organization_id/product/:product_id/examples',
    EResourceMethod.Get,
    /** @todo check casing */
    orgIdParam(productIdParam())
  ),
  getProductSummaryLatest: createResourceBuilder(
    '/overview/product/:product_id/summary-latest',
    EResourceMethod.Get,
    productIdParam()
  ),
  getSummaryExpirations: createResourceBuilder('/overview/summary-expirations', EResourceMethod.Get),
  getSummaryUserLicenses: createResourceBuilder(
    '/overview/org/:organization_id/product/:product_id/summary-user-licenses',
    EResourceMethod.Get,
    orgIdParam(productIdParam())
  ),
  summaryMyLicenses: createResourceBuilder(
    '/overview/org/:organization_id/product/:product_id/summary-my-licenses',
    EResourceMethod.Get,
    orgIdParam(productIdParam())
  ),
  getOrganizationSummary: createResourceBuilder(
    '/overview/org/:organization_id/summary',
    EResourceMethod.Get,
    orgIdParam()
  ),
};
